import { useEffect } from 'react';
import { Constants, ImagePath, ImageRelativePath, Page_Padding } from '../../shared/constants';
import {
    Box,
    Button,
    Grid2,
    Typography,
} from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import UiUxDevelopement from './UiUxDevelopement';
import CourseCard from '../../shared/components/CourseCard';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import useResponsive from '../../shared/utils/Responsive';
import { useCourseDetail, useNewCourseDetail, useNewCourseDetail1 } from '../../assets/api/useGetApi';
import { ImgSkeleton, SkeletonCom } from '../../shared/utils/SkeletonCom';
import { useNavigate, useParams } from 'react-router-dom';
import useImageStore from '../../shared/store/useImageStore';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';

// export const ImageSection = ({ itemData, isLoading }) => {
//     const { slug } = useParams();
//     const isSmallScreen = useResponsive("md")
//     const isSmallScreen1 = useResponsive("sm")
//     const { isImgLoading, setIsImgLoading } = useImageStore();
//     useEffect(() => {
//         setIsImgLoading(true);
//         const timer = setTimeout(() => {
//             setIsImgLoading(false);
//         }, 3);

//         return () => clearTimeout(timer);
//     }, [slug]);
//     return (
//         <Grid2 container spacing={2} px={Page_Padding}>
//             <Grid2 size={{ xs: 12, sm: 8 }}>
//                 <img
//                     src={itemData[0].img}
//                     alt={itemData[0].title}
//                     width="100%"
//                     style={{
//                         objectFit: "cover",
//                         height: isSmallScreen ? "260px" : "400px",
//                         display: (isImgLoading && isLoading) ? "none" : "block",
//                         borderRadius: isSmallScreen ? "10px" : "auto"

//                     }}
//                     onLoad={() => setIsImgLoading(false)}
//                     onError={() => setIsImgLoading(false)}
//                 />

//                 {(isImgLoading && isLoading) && (
//                     <ImgSkeleton />
//                 )}
//             </Grid2>
//             {
//                 !isSmallScreen1 &&
//                 <Grid2 container size={{ xs: 12, sm: 4 }} spacing={2}>
//                     {itemData.slice(1).map((item, index) => (
//                         <Grid2 key={index} size={{ xs: 6, sm: 12 }}>
//                             <img
//                                 src={item.img}
//                                 alt={item.title}
//                                 width="100%"
//                                 style={{ objectFit: "cover", maxHeight: "190px", borderRadius: isSmallScreen ? "10px" : "auto" }}
//                             />
//                         </Grid2>
//                     ))}
//                 </Grid2>
//             }


//         </Grid2>
//     )
// }



export const ImageSection = ({
    itemData,
    isLoading,
}) => {
    const { slug } = useParams();
    const isSmallScreen = useResponsive("sm");
    const { isImgLoading, setIsImgLoading } = useImageStore();

    useEffect(() => {
        setIsImgLoading(true);
        
        const timer = setTimeout(() => {
            setIsImgLoading(false);
        }, 300);

        return () => clearTimeout(timer);
    }, [slug, setIsImgLoading]);

    return (
        <Grid2 container spacing={"1rem"} px={Page_Padding}>
            {/* LEFT IMAGE */}
            <Grid2
                children
                size={{ xs: 12, sm: 6, md: 8 }}
                sx={{
                    height: 460,
                    borderRadius: "1rem",
                    backgroundImage: isImgLoading
                        ? "none"
                        : `url(${itemData?.[0]?.img})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "stretch",
                }}
            >
                {(isImgLoading || isLoading) && <ImgSkeleton  />}
            </Grid2>

            {/* RIGHT IMAGES (HIDDEN ON SMALL SCREEN) */}
            {!isSmallScreen && (
                <Grid2


                    size={{ xs: 12, sm: 6, md: 4 }}
                    container
                    direction="column"
                    spacing={"1rem"}
                    sx={{ height: 460 }}
                >
                    {itemData?.slice(1, 3).map((item, index) => (
                        <Grid2
                            key={index}
                            children
                            size={12}
                            sx={{
                                flex: 1,
                                borderRadius: "1rem",
                                backgroundImage: `url(${item.img})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                            }}
                        />
                    ))}
                </Grid2>
            )}
        </Grid2>
    );
};

const CourseDetail = () => {
    const { open: openWarning, handleClickOpen: handleClickOpenWarning, handleClose: handleCloseWarning } = useDialog();
    const navigate = useNavigate();
    const { slug, apartments_id } = useParams();
    const { data: newCoursesDetail, isLoading: isNewCourseDetailLoading, error, isLoadingError } = useNewCourseDetail1({ slug: slug, apartments_id: apartments_id })
    const { data: coursesDetail, isLoading } = useCourseDetail(slug);
    const { data: courseDetailForType, isLoading: isloadingtypeCourse } = useNewCourseDetail({ slug: slug })
    const itemData = [
        { img: `${ImagePath}${ImageRelativePath}${coursesDetail?.data?.cover_image}`, title: 'Image 1' },
        { img: Constants.customImages.CourseDetailFrame2, title: 'Image 2' },
        { img: Constants.customImages.CourseDetailFrame3, title: 'Image 3' }
    ];

    const renderCourseCards = () =>
        !isLoading
            ? coursesDetail?.related_courses?.slice(0,10)?.map((item, index) => (
                <Grid2
                    children
                    key={index}
                    size={{ xs: 12, sm: 5.7, lg: 3.7 }}
                    sx={{ flex: "0 0 auto", display: "flex", alignItems: "stretch" }}
                >
                    <CourseCard item={item} />
                </Grid2>
            ))
            : [...Array(6)].map((_, index) => (
                <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto" }}>
                    <SkeletonCom />
                </Grid2>
            ));

    // useEffect(() => {
    //     if (newCoursesDetail?.data?.length === 0 && courseDetailForType?.data?.type !== 8 && !isloadingtypeCourse) {
    //         handleClickOpenWarning();
    //     }
    // }, [newCoursesDetail,courseDetailForType]);
    return (
        <>
            <Box className="body course_detail">
                <ImageSection itemData={itemData} isLoading={isLoading} />
                <CustomDivider orientation='horizontal' />

                <UiUxDevelopement course_id={coursesDetail?.data?.id} />
                <CustomDivider orientation='horizontal' />

                {coursesDetail?.related_courses?.length <= 3 ? (
                    <Box px={Page_Padding}>
                        <Typography variant="h5" my={3}>
                            Related Courses
                        </Typography>
                        <Grid2 container spacing={"30px"}>{renderCourseCards()}</Grid2>
                    </Box>

                ) : (
                    <Box px={Page_Padding}>
                        <Typography variant="h5" mb={"-35px"}> Related Courses</Typography>
                        <HorizontalScroll size={3}>{renderCourseCards()}</HorizontalScroll>
                    </Box>

                )}
                <CustomDivider orientation='horizontal' />

                {
                    apartments_id &&


                    <MainDialogBox open={openWarning} handleClose={handleCloseWarning} width={"40%"}
                        isShowCross={false}
                        disableBackdropClick={true}
                        disableEscapeKeyDown={true}
                        mainsx={{
                            '& .MuiBackdrop-root': {
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            },
                        }}
                    >
                        <Typography>
                            Unfortunately, this course isn't available in this apartment. Feel free to explore other available courses.
                        </Typography>

                        <CustomDivider />
                        <Button onClick={() => navigate('/Courses')}>Explore Courses</Button>

                    </MainDialogBox>
                }
            </Box>
        </>
    );
};

export default CourseDetail;
